import { EXPRESS_API } from 'configs/api/expressApi';
import { useAuth } from 'lib/context';
import { useToastError } from 'lib/hooks';
import { useQuery, useQueryClient } from 'react-query';
import { messagesKeys } from './messagesKeys';
import { IMessagesParams, MessageUsersParams } from './types';
import { conversationsKeys } from '../conversations/queryKeys';

export const getSmsMessages = async ({
  search = '',
  page = 0,
  size = 10,
  userId = undefined,
  from,
  to = new Date().toISOString(),
  type = undefined,
}: MessageUsersParams): Promise<any> => {
  const params: MessageUsersParams = {
    start: page * size,
    limit: size,
    from,
    to,
    type,
  };

  if (search) {
    params.search = search;
  }

  if (userId) {
    params.userId = userId;
  }

  if (type) {
    params.type = type;
  }

  const response = await EXPRESS_API.get(`/sms/messages`, {
    params: { ...params, to: new Date().toISOString() },
  });

  return response.data;
};

export const useMessagesQuery = (params: IMessagesParams) => {
  const { userData } = useAuth();
  const { showError } = useToastError();
  const queryClient = useQueryClient();
  return useQuery(messagesKeys.messages(params), () => getSmsMessages(params), {
    onSuccess: res => {
      if (res.chats && res.chats.length === 1) {
        queryClient.invalidateQueries(
          conversationsKeys.single_chat(res.chatId)
        );
      }
    },
    onError: showError,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: userData?.customer?.smsEnabled?.toString() === '1',
  });
};
